export interface Client {
  id: number;
  user_id: number;
  business_name: string;
  business_type: string;
  industry: string;
  created_at: string;
}

const BUSINESS_TYPE_LABELS: Record<string, string> = {
  general: "General",
  sole_proprietor: "Sole proprietor",
  llc: "LLC",
  s_corp: "S-Corp",
  c_corp: "C-Corp",
  partnership: "Partnership",
  nonprofit: "Nonprofit",
};

export const INDUSTRY_LABELS: Record<string, string> = {
  general: "General Business",
  contractor: "Contractor / Construction",
  dentist: "Dental / Medical Practice",
  restaurant: "Restaurant",
  personal: "Personal Finance",
  veterinarian: "Veterinary Practice",
  chiropractor: "Chiropractic Practice",
  "physical-therapy": "Physical Therapy",
  pharmacy: "Pharmacy",
  "home-health": "Home Health Care",
  attorney: "Law Practice",
  "accounting-firm": "Accounting / CPA Firm",
  architect: "Architecture Firm",
  "engineering-firm": "Engineering Firm",
  consulting: "Consulting",
  "real-estate-agent": "Real Estate Agent / Broker",
  "insurance-agency": "Insurance Agency",
  electrician: "Electrician",
  plumber: "Plumber",
  hvac: "HVAC",
  landscaping: "Landscaping / Lawn Care",
  "auto-mechanic": "Auto Repair / Mechanic",
  roofing: "Roofing Contractor",
  "retail-store": "Retail Store",
  ecommerce: "E-Commerce",
  bakery: "Bakery",
  "food-truck": "Food Truck",
  catering: "Catering",
  "bar-brewery": "Bar / Brewery",
  "coffee-shop": "Coffee Shop",
  "salon-barbershop": "Salon / Barbershop",
  spa: "Spa / Massage Therapy",
  "gym-fitness": "Gym / Fitness Studio",
  daycare: "Daycare / Child Care",
  "cleaning-service": "Cleaning Service",
  photography: "Photography",
  "graphic-design": "Graphic Design",
  "web-development": "Web Development / Software",
  "marketing-agency": "Marketing Agency",
  trucking: "Trucking / Freight",
  "taxi-rideshare": "Taxi / Rideshare",
  "auto-dealership": "Auto Dealership",
  "moving-company": "Moving Company",
  "property-management": "Property Management",
  "real-estate-investor": "Real Estate Investor",
  farming: "Farming / Agriculture",
  ranching: "Ranching / Livestock",
  tutoring: "Tutoring / Education",
  "hotel-motel": "Hotel / Motel / B&B",
  nonprofit: "Nonprofit Organization",
};

export function formatBusinessType(type: string): string {
  return BUSINESS_TYPE_LABELS[type] ?? type.replace("_", " ");
}

export function formatIndustry(industry: string): string {
  return INDUSTRY_LABELS[industry] ?? industry.replace("_", " ");
}
